import { render, staticRenderFns } from "./StockItemsLoading.vue?vue&type=template&id=cabfaa28&scoped=true"
import script from "./StockItemsLoading.vue?vue&type=script&lang=js"
export * from "./StockItemsLoading.vue?vue&type=script&lang=js"
import style0 from "./StockItemsLoading.vue?vue&type=style&index=0&id=cabfaa28&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabfaa28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cabfaa28')) {
      api.createRecord('cabfaa28', component.options)
    } else {
      api.reload('cabfaa28', component.options)
    }
    module.hot.accept("./StockItemsLoading.vue?vue&type=template&id=cabfaa28&scoped=true", function () {
      api.rerender('cabfaa28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/StockItemsLoading.vue"
export default component.exports